export const FETCH_AD_REQUEST = 'FETCH_AD_REQUEST';
export const FETCH_AD_START = 'FETCH_AD_START';
export const FETCH_AD_SUCCESS = 'FETCH_AD_SUCCESS';
export const FETCH_AD_FAILED = 'FETCH_AD_FAILED';

export const CHANGE_AD_PAGE = 'CHANGE_AD_PAGE';

export const SAVE_APPLY_START = 'SAVE_APPLY_START';
export const SAVE_APPLY = 'SAVE_APPLY';
export const SAVE_APPLY_SUCCESS = 'SAVE_APPLY_SUCCESS';
export const SAVE_APPLY_FAILED = 'SAVE_APPLY_FAILED';

export const ADPAGE_TYPE_TRAFFIC = 'RpmTraffic';
export const ADPAGE_TYPE_FORM = 'RpmForm';

export const FETCH_RELATED_ADS_START = 'FETCH_RELATED_ADS_START';
export const FETCH_RELATED_ADS_REQUEST = 'FETCH_RELATED_ADS_REQUEST';
export const FETCH_RELATED_ADS_SUCCESS = 'FETCH_RELATED_ADS_SUCCESS';
export const FETCH_RELATED_ADS_FAILED = 'FETCH_RELATED_ADS_FAILED';
export const MAX_AD_PAGE_VISIBLE_RELATED_ADS = 6;

export const NAVIGATE_AD_PAGE = 'NAVIGATE_AD_PAGE';
export const NAVIGATE_TO_HOME = 'NAVIGATE_TO_HOME';
export const NAVIGATE_TO_HOME_OR_LAST_SEARCH = 'NAVIGATE_TO_HOME_OR_LAST_SEARCH';
export const ENABLE_RELATED_ADS_FETCH = 'ENABLE_RELATED_ADS_FETCH';



// WEBPACK FOOTER //
// ./app/AdPage/constants.js